export default {
  common: {
    email: 'Email',
    emailPlaceholder: "your{'@'}email.com",
    password: 'Password',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    or: 'Or',
  },
  login: {
    pageTitle: 'Log in',
    cardTitlePrefix: 'Log',
    cardTitleAccent: 'In',
    subtitle: 'Welcome back. Authenticate to continue.',
    forgotPassword: 'Forgot password?',
    submit: 'Log in',
    submitting: 'Signing in…',
    noAccount: 'No account?',
    signUp: 'Sign up',
    invalidCredentials: 'Invalid email or password.',
    sessionExpired: 'Your session expired. Please log in again.',
  },
  register: {
    pageTitle: 'Sign up',
    cardTitlePrefix: 'Create',
    cardTitleAccent: 'Account',
    subtitle: 'Sign up to start collecting game keys.',
    passwordHint: 'Minimum 8 characters',
    agreePrefix: 'I agree to the',
    terms: 'Terms & Conditions',
    and: 'and',
    privacy: 'Privacy Policy',
    submit: 'Create account',
    submitting: 'Creating account…',
    haveAccount: 'Have account?',
    logIn: 'Log in',
    acceptTerms: 'Please accept the Terms & Conditions to continue.',
    passwordTooShort: 'Password must be at least 8 characters.',
    createFailed: 'Could not create account. Try a different email.',
  },
  reset: {
    pageTitle: 'Reset password',
    backToLogin: 'Back to login',
    cardTitle: 'Reset password',
    cardTitlePrefix: 'Reset',
    cardTitleAccent: 'Password',
    description: "Enter your email address and we'll send you instructions to reset your password.",
    submit: 'Send instructions',
    submitting: 'Sending…',
    genericError: 'Something went wrong. Please try again.',
    sentTitle: 'Check your email',
    sentText: "We've sent reset instructions to {email}",
  },
  twofa: {
    // Login step
    stepTitlePrefix: 'Two-factor',
    stepTitleAccent: 'Verification',
    stepTotpHint: 'Enter the 6-digit code from your authenticator app.',
    stepEmailHint: 'We sent a 6-digit code to your email. Enter it below.',
    verify: 'Verify',
    verifying: 'Verifying…',
    resend: 'Resend code',
    resent: 'Code sent ✓',
    invalidCode: 'Invalid or expired code.',
    back: 'Back',
    useRecoveryCode: 'Use recovery code',
    useAuthCode: 'Use authenticator code',
    recoveryHint: 'Enter one of your saved recovery codes.',
    recoveryPlaceholder: 'recovery-code',
    codeExpires: 'Code expires in',
    // Settings card
    title: 'Two-factor authentication',
    description: 'Add a second step at login to keep your account secure.',
    statusEnabled: 'Enabled',
    statusDisabled: 'Disabled',
    methodTotp: 'Authenticator app',
    methodTotpDesc: 'Use Google Authenticator, Authy, 1Password, etc.',
    methodEmail: 'Email',
    methodEmailDesc: 'Get a one-time code by email at each login.',
    chooseMethod: 'Choose a method',
    setUp: 'Set up',
    scanQr: 'Scan this QR with your authenticator app, then enter the 6-digit code.',
    orEnterKey: 'Or enter this key manually:',
    emailCodeSent: 'We emailed you a 6-digit code. Enter it below to confirm.',
    enterCode: 'Verification code',
    enable: 'Enable',
    enabling: 'Enabling…',
    cancel: 'Cancel',
    disable: 'Disable',
    disabling: 'Disabling…',
    disableTotpHint: 'Enter a current code from your authenticator app to turn off 2FA.',
    disableEmailHint: 'Send yourself a code, then enter it to turn off 2FA.',
    sendCode: 'Send code',
    codeSent: 'Code sent',
    enableFailed: 'Could not enable. Check the code and try again.',
    disableFailed: 'Could not disable. Check the code and try again.',
    enabledVia: 'Active via {method}',
  },
  verify: {
    pageTitle: 'Verify email',
    verifyingTitle: 'Verifying…',
    verifyingText: 'Confirming your email address.',
    successTitle: 'Email verified',
    successTitlePrefix: 'Email',
    successTitleAccent: 'Verified',
    successText: 'Your email address has been successfully verified. You can now access all features.',
    goToDashboard: 'Go to dashboard',
    failedTitle: 'Verification failed',
    failedTitlePrefix: 'Verification',
    failedTitleAccent: 'Failed',
    resendEmail: 'Resend email',
    invalidLink: 'This verification link is invalid or has expired.',
    noToken: 'No verification token was provided.',
  },
};
